// Imports
import { useState, Fragment, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
//Language
import { useIntl } from "react-intl";

// Controls
import { Grid } from '@mui/material';
import { Button, Modal, ModalBody, ModalFooter } from "@gpstrackit/react-controls";
import UnitTypeEventsList from 'Modules/events/.components/unitTypeEvents'


// Actions
import {
    showUnitTypeEventsHide,
    clearRedux,
} from "Redux/actions";

// Styles
import './showUnitTypeEvents.scss';

const ShowUnitTypeEvents = (props) => {
    const { manufacturerId, manufacturer } = props
    const { messages } = useIntl();
    const dispatch = useDispatch();

    //initial filter status
    const initialStateFilters = {
        esn: props?.device?.ESN || '',
    }
    //Table reference
    const tableRef = useRef(null);

    //redux states

    const openModal = useSelector(state => state.showUnitTypeEventsRedux.openModal);
    const result = useSelector(state => state.showUnitTypeEventsRedux.result);
    const loading = useSelector(state => state.showUnitTypeEventsRedux.loading);
    const unitType = useSelector(state => state.showUnitTypeEventsRedux.unitType);


    const hide = () => {
        dispatch(showUnitTypeEventsHide());
        dispatch(clearRedux("UNIT_TYPE_EVENTS"))
    }

    return (
        <Fragment>
            <Modal
                open={openModal}
                title={messages["show_unit_type_events_title"]}
                handleClose={() => hide()}
                position="right"
                loading={loading}
                size="medium"
            >
                <ModalBody style={{ backgroundColor: '#f8f8f8' }}>
                    <Grid>
                        <Grid xxs="12">
                            <UnitTypeEventsList manufacturerId={manufacturerId} unitTypeId={unitType.id} unitTypeParam={unitType} manufacturerParam={manufacturer} from={"manufacturer"} />
                        </Grid>
                    </Grid>
                </ModalBody>
                <ModalFooter>
                    <Button className="btn btn-dark-blue"
                        onClick={() => hide()}
                    >
                        {messages["common_cancel"]}
                    </Button>
                </ModalFooter>
            </Modal>

        </Fragment>
    );
};

export default ShowUnitTypeEvents;